// src/components/InterpretationCitiesSelector.jsx
import React from "react";
import { TextField, Chip, Typography } from "@mui/material";

export default function InterpretationCitiesSelector({
  interpretationCityInput,
  selectedInterpretationCities,
  handleInterpretationCityInputChange,
  handleInterpretationCityKeyDown,
  handleRemoveInterpretationCity,
}) {
  return (
    <>
      <Typography className="pt-4 font-medium text-purple-800">
        Ciudades donde necesitas la interpretación
      </Typography>

      <TextField
        fullWidth
        label="Escribe y presiona Enter"
        placeholder="Ej: Pekín, Shanghái, etc."
        value={interpretationCityInput}
        onChange={(e) => handleInterpretationCityInputChange(e.target.value)}
        onKeyDown={handleInterpretationCityKeyDown}
      />

      <div className="flex flex-wrap gap-2 pt-2">
        {selectedInterpretationCities.map((city) => (
          <div key={city}>
            <Chip
              label={city}
              onDelete={() => handleRemoveInterpretationCity(city)}
              color="secondary"
              className="shadow-lg hover:scale-105 transition-transform"
            />
          </div>
        ))}
      </div>
    </>
  );
}
